import { Component, Input, OnInit } from '@angular/core';
import { Chart } from '../chart';
import { defaultBarChartConfig } from './config';

@Component({
  selector: 'cc-lg-bar-chart',
  templateUrl: './horizontal-bar-chart.component.html',
  styleUrls: ['./horizontal-bar-chart.component.css', './../../commons.scss']
})
export class HorizontalBarChartComponent implements OnInit {
  public barChartOptions;

  @Input() chartsData: Chart[];
  @Input() configMapper = config => config;

  ngOnInit() {
    this.barChartOptions = this.configMapper(defaultBarChartConfig);
  }
}
